import { createReportCommentSchema, createReportRemarkSchema } from '#shared/types';
import { RESOURCE } from '#client/lib/routes';

/**
 * Report comments and report remarks. Both are a code and a description,
 * managed the same way and differing only in where the report prints them, so
 * one set of pages serves both and this is what differs.
 */
export interface PhraseCatalogue {
  /** The permission prefix: `reportComment.create`, `reportRemark.edit` and so on. */
  permission: 'reportComment' | 'reportRemark';
  path: string;
  title: string;
  subtitle: string;
  noun: string;
  nounPlural: string;
  /** Capitalised, for toasts. */
  label: string;
  schema: typeof createReportCommentSchema;
}

export const REPORT_COMMENTS: PhraseCatalogue = {
  permission: 'reportComment',
  path: RESOURCE.reportComments,
  title: 'Report comments',
  subtitle: 'Reusable comments that can be attached to reports',
  noun: 'comment',
  nounPlural: 'comments',
  label: 'Comment',
  schema: createReportCommentSchema,
};

export const REPORT_REMARKS: PhraseCatalogue = {
  permission: 'reportRemark',
  path: RESOURCE.reportRemarks,
  title: 'Report remarks',
  subtitle: 'Reusable remarks, printed above the comments with no heading',
  noun: 'remark',
  nounPlural: 'remarks',
  label: 'Remark',
  schema: createReportRemarkSchema,
};
